// const boxes = document.querySelectorAll('.product-content-container .add-to-cart-containe');
//   const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('addToCartButton-is-fixed');
//       } else {
//         entry.target.classList.remove('addToCartButton-is-fixed');
//       }
//     });
//   });

//   boxes.forEach(box => {
//     observer.observe(box);
//   });

// document.addEventListener("DOMContentLoaded", (event) => {
//   const addToCartButton = document.getElementById("addToCartButton");
// var sticky = document.getElementById("addToCartButton").offsetTop;
// window.onscroll = function() {myFunction()};



// function myFunction() {
//   if (window.pageYOffset > sticky - 1000) {
//     addToCartButton.classList.add("sticky-addtocart");
//   } else {
//     addToCartButton.classList.remove("sticky-addtocart");
//   }
// }
// });

/********sticky_add_to_cart----start*******/
document.querySelectorAll('.addtocart_sticky').forEach(function(element) {
  element.addEventListener('click', function() {
    console.log(46545);
    document.querySelector('.add-to-cart-container #addToCartButton').click();
  });
});

// function handleIntersection(entries, observer) {
//     entries.forEach(entry => {
//         const addtocart_sticky = document.querySelector('.add-to-cart-container-sticky');
//         if (entry.isIntersecting) {
//             addtocart_sticky.classList.remove('show_btn');
//         } else {
//             addtocart_sticky.classList.add('show_btn'); 
//         }
//     });
// }

// const observer = new IntersectionObserver(handleIntersection);
// const addToCartContainer = document.querySelector('.add-to-cart-container');

// if (addToCartContainer) {
//     observer.observe(addToCartContainer);
// }

function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        const addtocart_sticky = document.querySelector('.add-to-cart-container-sticky');
        
        if (entry.isIntersecting) {
            addtocart_sticky.classList.remove('show_btn');
        } else {
            addtocart_sticky.classList.add('show_btn'); 
        }
    });
}

const observer = new IntersectionObserver(handleIntersection);
const addToCartContainer = document.querySelector('.add-to-cart-container');

if (addToCartContainer) {
    observer.observe(addToCartContainer);
}

window.addEventListener('scroll', function() {
    const addtocart_sticky = document.querySelector('.add-to-cart-container-sticky');
    const scrollHeight = window.scrollY;

    if (scrollHeight < 350) {
        addtocart_sticky.classList.add('not_show');
    } else {
        addtocart_sticky.classList.remove('not_show');
    }
});



/********sticky_add_to_cart----end*******/


document.addEventListener("DOMContentLoaded", function() {
var count_ctm_varint_options = document.querySelectorAll('.ctm_varint_options').length;
  if(count_ctm_varint_options > 0){
    var firstElement = document.querySelector(".ctm_varint_options");
    firstElement.classList.add("ctm_varint_options_active");
    
    document.querySelectorAll(".ctm_varint_options").forEach(function(element) {
        element.addEventListener("click", function() {
            var closestAncestor = this.closest('.custom_other_product_options');
            closestAncestor.querySelectorAll('.ctm_varint_options').forEach(function(option) {
                option.classList.remove("ctm_varint_options_active");
            });
            this.classList.add('ctm_varint_options_active');
        });
    });
}
});


